// src/components/store/QuickCartComponents/CheckTermsComponent.jsx
import React from "react";
import * as Checkbox from "@radix-ui/react-checkbox";
import { CheckIcon, ExternalLink } from "lucide-react";
import { useSalesContext } from "../../../contexts/SalesContext";

const TERMS_URL = "/terminos";

export const CheckTermsComponent = ({ checked, onChange }) => {
  const { newSalesTerms, setNewSalesTerms } = useSalesContext();
  // Si vienen props, úsalas; si no, usa el contexto
  const isChecked = checked !== undefined ? checked : newSalesTerms;
  const handleChange = onChange || setNewSalesTerms;

  // Función para manejar el cambio correctamente
  const handleCheckChange = (value) => {
    // Si es una función custom, llamarla con el valor booleano
    if (onChange) {
      onChange(value);
    } else {
      // Si no, usar el setter del contexto
      setNewSalesTerms(value);
    }
  };

  return (
    <div className="flex flex-col bg-white rounded-xl gap-3 mb-24">
      <h3 className="text-lg font-medium p-0 m-0 flex flex-col">
        Términos y condiciones
      </h3>

      <div className="flex justify-between gap-4 items-center">
        <label
          htmlFor="terms"
          className="text-base font-base peer-disabled:cursor-not-allowed peer-disabled:opacity-70 leading-6"
        >
          {"Marcar la casilla para confirmar que has leído y aceptado los "}
          <a
            href={TERMS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline inline-flex items-center text-blue-600"
          >
            términos y condiciones
            <ExternalLink className="ml-1 h-3 w-3" />
          </a>
        </label>
        <Checkbox.Root
          className="flex min-h-8 min-w-8 max-h-8 max-w-8 appearance-none items-center justify-center rounded-md border border-blue-600 bg-white outline-none hover:bg-gray-100 focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 gap-2"
          checked={isChecked}
          onCheckedChange={handleCheckChange} // ← Usar la función wrapper
          id="terms"
        >
          <Checkbox.Indicator className="text-blue-600">
            <CheckIcon strokeWidth={3} />
          </Checkbox.Indicator>
        </Checkbox.Root>
      </div>
    </div>
  );
};

export default CheckTermsComponent;
